<template>
  <div class="card order-details"  v-if="data.length!=0" id="initial-order" ref="initialorder">
    <div class="card-header">Initial Order Details</div>
    <div class="card-body table-scroll">
      <table class="table table-borderless">
        <thead class="thead-light">
          <tr>
            <th>SAP Order Number</th>
            <th>SAP SKU</th>
            <th>SAP Line Item Number</th>
            <th>Quantity</th>
            <th>High Level Item</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.SAPLineItemNumber">
            <td>{{ item.SAPOrderNumber }}</td>
            <td>{{ item.SAPSKU }}</td>
            <td>{{ item.SAPLineItemNumber }}</td>
            <td>{{ item.QUANTITY }}</td>
            <td>{{ item.HIGHLEVELITEM }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card order-details" v-else id="initial-order" ref="initialorder">
      <div class="card-header">Initial Order Details</div>
    <div class="card-body ">
        No Initial Order Found.
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenseCheckerInitialOrderDetails',
  props: {
    data: { type: Array, default: () => ([]) }
  },
  mounted () {
    this.$emit('setSiblingHeight', this.$refs.initialorder.clientHeight)
  }
}
</script>

<style>
.order-details.card {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-inital-order-details.vue